import { css, SerializedStyles } from '@emotion/react';

// Static CSS variables for the typography families
const STATIC_TYPOGRAPHY_STYLES = `

    [data-family-body] {
        --hc-font-family: var(--hc-body-font-family);
        --hc-text-transform: var(--hc-body-text-transform);
        --hc-font-weight-default: var(--hc-body-font-weight-default);
        --hc-font-weight-regular: var(--hc-body-font-weight-regular, var(--hc-body-font-weight-default));
        --hc-font-weight-semi-bold: var(--hc-body-font-weight-semi-bold, var(--hc-body-font-weight-default));
        --hc-font-weight-bold: var(--hc-body-font-weight-bold, var(--hc-body-font-weight-default));
    }

    [data-family-caption] {
        --hc-font-family: var(--hc-caption-font-family);
        --hc-text-transform: var(--hc-caption-text-transform);
        --hc-font-weight-default: var(--hc-caption-font-weight-default);
        --hc-font-weight-regular: var(--hc-caption-font-weight-regular, var(--hc-caption-font-weight-default));
        --hc-font-weight-semi-bold: var(--hc-caption-font-weight-semi-bold, var(--hc-caption-font-weight-default));
        --hc-font-weight-bold: var(--hc-caption-font-weight-bold, var(--hc-caption-font-weight-default));
    }

    [data-family-heading] {
        --hc-font-family: var(--hc-heading-font-family);
        --hc-text-transform: var(--hc-heading-text-transform);
        --hc-font-weight-default: var(--hc-heading-font-weight-default, var(--hc-heading-font-weight-default));
        --hc-font-weight-regular: var(--hc-heading-font-weight-regular, var(--hc-heading-font-weight-default));
        --hc-font-weight-semi-bold: var(--hc-heading-font-weight-semi-bold, var(--hc-heading-font-weight-default));
        --hc-font-weight-bold: var(--hc-heading-font-weight-bold, var(--hc-heading-font-weight-default));
    }

    [data-family-hero] {
        --hc-font-family: var(--hc-hero-font-family);
        --hc-text-transform: var(--hc-hero-text-transform);
        --hc-font-weight-default: var(--hc-hero-font-weight-default);
        --hc-font-weight-regular: var(--hc-hero-font-weight-regular, var(--hc-hero-font-weight-default));
        --hc-font-weight-semi-bold: var(--hc-hero-font-weight-semi-bold, var(--hc-hero-font-weight-default));
        --hc-font-weight-bold: var(--hc-hero-font-weight-bold, var(--hc-hero-font-weight-default));
    }

    [data-family-price] {
        --hc-font-family: var(--hc-price-font-family);
        --hc-text-transform: var(--hc-price-text-transform);
        --hc-font-weight-default: var(--hc-price-font-weight-default);
        --hc-font-weight-regular: var(--hc-price-font-weight-regular, var(--hc-price-font-weight-default));
        --hc-font-weight-semi-bold: var(--hc-price-font-weight-semi-bold, var(--hc-price-font-weight-default));
        --hc-font-weight-bold: var(--hc-price-font-weight-bold, var(--hc-price-font-weight-default));
    }

`;

const STATIC_UTILITIES = `

    [data-truncate] {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    [data-block-link] {
        &:before {
            content: '';
            bottom: 0;
            right: 0;
            top: 0;
            left: 0;
            overflow: hidden;
            position: absolute;
            white-space: nowrap;
        }
    }

    [data-subtle-scrollbars] {
        @media (pointer: fine) {
            scrollbar-width: thin;
            scrollbar-color: transparent transparent;
            &:hover {
                scrollbar-color: var(--hc-color-scrollbar) white;
            }
        }
    }

    [data-focus-ring] {
        -webkit-tap-highlight-color: transparent;
        outline: none;
        &:focus-visible {
            outline: 2px solid var(--hc-color-action-focus);
        }
    }

    [data-offscreen] {
        position: absolute;
        left: 0;
        bottom: -1px;
        z-index: -1;
        opacity: 0;
    }

    [data-hidden] {
        visibility: hidden;
    }

    [data-bi-directional]:dir(rtl) {
        /* Only apply the flip in RTL */
        transform: rotateY(180deg);
    }
`;

const STATIC_FIELD_STYLES = `

    [data-input-base], [data-textarea-base], [data-select-base] {
        outline: none;
        background-image: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        color: currentColor;
        -webkit-text-fill-color: currentColor;
        font-family: var(--hc-body-font-family);
        font-weight: var(--hc-body-font-weight-default);
    }

    [data-input-base], [data-textarea-base] {
        &::placeholder {
            color: var(--hc-color-text-light);
        }
    }

    [data-textarea-base] {
        resize: vertical;
    }

    [data-select-base] {
        border-radius: 0;
        user-select: none;
        &::-ms-expand {
            display: none;
        }
        font-size: 1rem;
    }
`;

export const SERIALIZED_STATIC_STYLES: SerializedStyles = css(
    [STATIC_TYPOGRAPHY_STYLES, STATIC_UTILITIES, STATIC_FIELD_STYLES].join()
);
